import React, { useCallback } from 'react'
import { List, Map } from 'immutable'
import { compose } from 'recompose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux, useDispatch } from 'react-redux'
import { connect as connectStaticText } from '../../StaticText/connect'
import { setEventDefault } from '../../../services/event-tracking/actions'
import {
  PLAN_SKU_INCREASED_PRICE_MONTHLY,
  PLAN_SKU_INCREASED_PRICE_ANNUAL,
  PLAN_SKU_INCREASED_PRICE_GAIA_PLUS,
  formatPrice,
} from '../../../services/plans/index'
import { START_FREE_TRIAL_CLICKED_GA4_EVENT } from '../../../services/event-tracking/index'
import { USD } from '../../../services/currency/index'
import { H1 } from '../../Heading/index'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_BUTTON } from '../../ButtonSignUp/index'

function getPricing (props, text = '') {
  const { plans = Map() } = props
  const plansData = Map.isMap(plans) && Map.isMap(plans.get('data')) ? plans.get('data', Map()) : Map()
  const plansDataPlans = List.isList(plansData.get('plans')) ? plansData.get('plans', List()) : List()
  const currencyIso = plansDataPlans.getIn([0, 'currencyIso']) || USD
  const monthlyPlan = plansDataPlans.find((p) => p.get('sku') === PLAN_SKU_INCREASED_PRICE_MONTHLY) || Map()
  const annualPlan = plansDataPlans.find((p) => p.get('sku') === PLAN_SKU_INCREASED_PRICE_ANNUAL) || Map()
  const gaiaPlusPlan = plansDataPlans.find((p) => p.get('sku') === PLAN_SKU_INCREASED_PRICE_GAIA_PLUS) || Map()
  const monthlyCost = formatPrice(currencyIso, monthlyPlan.get('costs', List([0])).last(), false)
  const annualCost = formatPrice(currencyIso, annualPlan.get('costs', List([0])).last(), false)
  const gaiaPlusCost = formatPrice(currencyIso, gaiaPlusPlan.get('costs', List([0])).last(), false)

  return String(text)
    .replace(/\$\{ monthlyCost \}/g, monthlyCost)
    .replace(/\$\{ annualCost \}/g, annualCost)
    .replace(/\$\{ gaiaPlusCost \}/g, gaiaPlusCost)
}

function InviteFriendJumbotron (props) {
  const {
    staticText,
  } = props
  const dispatch = useDispatch()

  const onClickCtaHandler = useCallback(() => {
    // GA4 event
    dispatch(setEventDefault(
      START_FREE_TRIAL_CLICKED_GA4_EVENT.mergeDeep({
        ui_location: 'Invite Page',
      }),
    ))
  }, [dispatch])

  return (
    <div className="invite-friend-jumbotron">
      <div className="invite-friend-jumbotron__overlay" />
      <div className="invite-friend-jumbotron__content">
        <H1
          inverted
          className="invite-friend-jumbotron__header"
        >
          { staticText.getIn(['data', 'youreInvited']) }
        </H1>
        <div className="invite-friend-jumbotron__description">
          <p className="invite-friend-jumbotron__description-text">
            {staticText.getIn(['data', 'largestResource'])}
          </p>
          <p className="invite-friend-jumbotron__description-text invite-friend-jumbotron__description-text--last">
            {getPricing(props, staticText.getIn(['data', 'largestResource2']))}
          </p>
        </div>
        <div className="invite-friend-jumbotron__cta">
          <ButtonSignUp
            buttonClass={['button--primary invite-friend-jumbotron__cta-btn']}
            text={staticText.getIn(['data', 'startTrial'])}
            onClick={onClickCtaHandler}
            type={BUTTON_SIGN_UP_TYPE_BUTTON}
          />
        </div>
      </div>
    </div>
  )
}

InviteFriendJumbotron.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  plans: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'inviteFriendJumbotron' }),
  connectRedux(
    (state) => {
      return {
        plans: state.plans,
      }
    },
  ),
)(InviteFriendJumbotron)
